<template>
  <Transition name="menu">
    <div v-if="isOpen" class="fixed inset-0 z-50 md:hidden" @click="handleOverlayClick">
      <!-- Overlay -->
      <div class="absolute inset-0 bg-black/50" @click="handleOverlayClick"></div>
      
      <!-- Menu Panel -->
      <div class="menu-panel absolute top-0 h-full w-full bg-interactive-interactiveBg shadow-lg overflow-y-auto"
        @click.stop>
        <div class="flex flex-col h-full max-w-full mx-auto">
          <!-- Header -->
          <div class="flex items-center justify-end p-4">
            <button @click="$emit('close')" class="p-2 hover:bg-interactive-interactiveBgHover rounded-md">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          
          <!-- Menu Items -->
          <nav class="flex-1 p-4">
            <ul class="space-y-1">
              <li>
                <a href="https://app.hyperliquid.xyz/trade"
                  class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                  Perpetual
                </a>
              </li>
              <li>
                <a href="https://app.hyperliquid.xyz/trade"
                  class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                  1001x
                </a>
              </li>
              <li>
                <a href="https://app.hyperliquid.xyz/trade"
                  class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                  Spot
                </a>
              </li>
              <li>
                <a href="https://app.hyperliquid.xyz/portfolio"
                  class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="."
                  class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                  Referral
                </a>
              </li>
              <li>
                <a href="https://app.hyperliquid.xyz/announcements"
                  class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                  Rocket Launch
                </a>
              </li>
              <li>
                <a href="https://app.hyperliquid.xyz/announcements"
                  class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                  Airdrop
                </a>
              </li>
            </ul>
            
            <!-- Rewards Section -->
            <div class="mt-6 pt-6 border-t border-border-line">
              <h3 class="px-3 py-2 text-body2 text-t-third font-medium">Rewards</h3>
              <ul class="space-y-1">
                <li>
                  <a href="https://app.hyperliquid.xyz/points"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Points
                  </a>
                </li>
                <li>
                  <a href="https://hyperscreener.asxn.xyz/home"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Trade & Earn
                  </a>
                </li>
                <li>
                  <a href="https://app.hyperliquid-testnet.xyz/drip"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Rewards Hub
                  </a>
                </li>
              </ul>
            </div>
            
            <!-- More Section -->
            <div class="mt-6 pt-6 border-t border-border-line">
              <h3 class="px-3 py-2 text-body2 text-t-third font-medium">More</h3>
              <ul class="space-y-1">
                <li>
                  <a href="https://app.hyperliquid-testnet.xyz/trade"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Testnet
                  </a>
                </li>
                <li>
                  <a href="https://app.hyperliquid.xyz/explorer"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Explorer
                  </a>
                </li>
                <li>
                  <a href="https://app.hyperliquid.xyz/subAccounts"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Sub-Accounts
                  </a>
                </li>
                <li>
                  <a href="https://app.hyperliquid.xyz/API"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    API
                  </a>
                </li>
                <li>
                  <a href="https://app.hyperliquid.xyz/multiSig"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Multi-Sig
                  </a>
                </li>
                <li>
                  <a href="https://app.hyperliquid.xyz/announcements"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Announcements
                  </a>
                </li>
                <li>
                  <a href="https://hyperscreener.asxn.xyz/home"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Stats
                  </a>
                </li>
                <li>
                  <a href="/referral-program"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Docs
                  </a>
                </li>
                <li>
                  <a href="https://app.hyperliquid.xyz/points"
                    class="block px-3 py-2 text-body2 text-t-primary hover:bg-interactive-interactiveBgHover rounded-md">
                    Points
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'LandingPageMobileMenu',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  methods: {
    handleOverlayClick() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
/* Стили для меню */
.menu-panel {
  right: 0;
  left: 0;
}

/* На планшетах (728px и больше) - меню сбоку */
@media (min-width: 728px) {
  .menu-panel {
    right: 0;
    left: auto;
    width: 280px;
  }
}

/* Анимация появления меню */
.menu-enter-active,
.menu-leave-active {
  transition: opacity 0.3s ease;
}

.menu-enter-active .menu-panel,
.menu-leave-active .menu-panel {
  transition: transform 0.3s ease;
}

.menu-enter-from {
  opacity: 0;
}

.menu-enter-from .menu-panel {
  transform: translateX(100%);
}

.menu-leave-to {
  opacity: 0;
}

.menu-leave-to .menu-panel {
  transform: translateX(100%);
}

.menu-enter-to,
.menu-leave-from {
  opacity: 1;
}

.menu-enter-to .menu-panel,
.menu-leave-from .menu-panel {
  transform: translateX(0);
}
</style>

